/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ResultDisplayStyle {
    RESULT = 'RESULT',
    SPLIT = 'SPLIT',
    SIDE_BY_SIDE = 'SIDE_BY_SIDE',
}
